<template>
  <div class="commissionDatum">
    <!-- 销售佣金设定 标题 -->
    <div class="title">
      <label>
        <span class="enable-text">{{multiLanguage.templateName}} :</span>&nbsp;
        <el-select v-model="temp_name" size="small" @change="onTemplateChange" v-if="!newTempFlag">
          <el-option
            v-for="item in salesTemplate"
            :key="item.templateId"
            :label="`${item.templateId} ${multiLanguage[item.langKey]?'('+multiLanguage[item.langKey]+')':''}`"
            :value="item.templateId" v-if="item.isDisplay" >
          </el-option>
        </el-select>
        <input type="text" class='template_name' v-model="newTempName" v-if="newTempFlag"
                v-validate="{required:true,max:18,regex:/^([a-z]|[0-9]|[A-Z]|_)+$/}"
                name="newTempName"
                :style="errors.has('newTempName') ? 'border-color:#f44336;' : ''"
                @focus="onfocus=true" @blur="onfocus=false">
      </label>
      <div class="btn-box pull-right">
        <button class="btn" v-if="version == '1'" @click="submit">
          <span class="glyphicon glyphicon-edit"></span>
          {{multiLanguage.btnGroup.submit}}
        </button>
        <button class="btn" v-if="version == '1'" @click="createTemplate">
          <span class="glyphicon glyphicon-repeat"></span>
          {{newTempFlag?multiLanguage.btnGroup.back:multiLanguage.templateCreate}}
        </button>
      </div>
      <div v-if="newTempFlag">
        <span class="enable-text">{{multiLanguage.templateBase}} :</span>&nbsp;
        <el-select v-model="temp_name" size="small" style="width:250px;" @change="onTemplateChange">
          <el-option
            v-for="item in salesTemplate"
            :key="item.templateId"
            :label="`${item.templateId} ${multiLanguage[item.langKey]?'('+multiLanguage[item.langKey]+')':''}`"
            :value="item.templateId" v-if="item.isDisplay" >
          </el-option>
        </el-select>
      </div>
      <div v-if="!newTempFlag" :style="{'visibility':version==1?'hidden':'visible','height':viewBtn=='double'?'30px':'0px'}">
        <span class="enable-text">{{multiLanguage.templateHistory}} : </span>
        <el-select v-model="currentVersion"
          size="small" @change="onVersionChange" style="width:300px">
          <el-option
            v-for="item in tempHistory"
            :key="item.VERSION"
            :label="item.VERSION==0?`current`:`${item.UPDATE_BY} (${dataFormat(new Date(item.LAST_UPDATE))}) (${item.VERSION})`"
            :value="item.VERSION">
          </el-option>
        </el-select>
        <div class="clear"></div>
      </div>&nbsp;
      <div class="clear"></div>
    </div>
    
    <div>
    </div>
    <!-- 规则设定 内容 -->
    <rule-setting
      :enable="enable"
      :multiLanguage="multiLanguage"
      :version="version"
      :relation="relation"
      :currentIB="currentIB"
      :viewBtn="viewBtn"
      :rule="rule"
      :ruleSeq="ruleSeq"
      ref="ruleSetting"
      @checkId="checkIdFn">
    </rule-setting>
    <!-- 模态窗 -->
    <Modal v-model="showModal" size="sm" :header="false" :footer="false">
      <div v-show="!sucSave">
          <i class="glyphicon glyphicon-warning-sign color-red"></i>
          <span class="color-red">{{multiLanguage.submitResult.err}}</span>
      </div>
      <div v-show="sucSave">
          <i class="glyphicon glyphicon-ok color-green"></i>
          <span class="color-green">{{multiLanguage.submitResult.succeed}}</span>
      </div>
    </Modal>
  </div>
</template>

<script>
  var moment = require('moment');
  //moment().format();
  import { getTimeDiff,updateTimeByUtc } from 'common/js/util'
  import ruleSetting from './ruleSetting'
  import { URL_TEMPLATE_SAVE,URL_DEFAULT,URL_TOOLCHECKID, URL_TEMPLATE_GET,URL_TEMPLATE_HISTORY } from 'api/commissionApi'
  import { Modal,Btn,Dropdown} from 'uiv'
  import { Api } from 'api/commissionEnv'
  var api = new Api()
  export default {
    props: {
      multiLanguage: {
        type: Object,
        default: {},
      },
      version: {
        type: String,
        default: '',
      },
      viewBtn: {
        type: String,
        default: '',
      },
      curArea: {
        type: String,
        default: ''
      },
    },
    components: {
      Modal,
      ruleSetting,
      Btn,
      Dropdown
    },
    data() {
      return {
        newTempFlag: false,
        temp_name: this.$parent.currentTemplate,
        tempHistory: [],
        salesTemplate: [],
        ibTemplate: [],
        currentVersion:null,
        newTempName: '',
        UTCDIFF: getTimeDiff(),
        showModal: false,
        sucSave: false,
        enable: false,
        updateBy: '',
        confirmBy: '',
        lastUpdate: '',
        lastConfirm: '',
        relation: [],
        rule: [],
        currentIB:{},
        specialIB: [],
        overlookIB: [],
        isConfirm: false,
        ruleSeq: [],
      }
    },
    mounted () {
      this.pageInit()
    },
    computed: {
      updateData () { // 需要修改的数据
        let newRule = []
        if (!this.enable) {
          for (let ruleLevel of this.rule) {
            let newRuleLevel = []
            for (let ruleItem of ruleLevel) {
              if ((!ruleItem.enableCommTarget && ruleItem.value.trim() !== '') || (ruleItem.enableCommTarget && ruleItem.commTarget !== ''  && ruleItem.value.trim() !== '')) newRuleLevel.push(ruleItem)
            }
            newRule.push(newRuleLevel)
          }
        }
        let temp_lang = 'auto'
        if(this.salesTemplate && this.salesTemplate.length>0){
          this.salesTemplate.forEach(it=>{
            if(it.templateId==this.temp_name) temp_lang = it.langKey;
          })
        }
        return {
          newTempFlag: this.newTempFlag,
          updateBy: JSON.parse(sessionStorage.user).user_name,
          rule: this.enable ? this.rule : newRule,
          tmplateName: this.newTempFlag?this.newTempName:this.temp_name,
          tmpLang: this.newTempFlag?'auto':temp_lang,
        }
      },
    },
    methods: {
      pageInit (version) { // 初始化数据
        this.$http.get(api.getUrl20(this.curArea,URL_TEMPLATE_GET+'/'+this.temp_name)).then(res => {
          if (res.data.code == 200 && res.data.msg == 'OK') {
            let data = res.data.data
            this.enable = true
            this.rule = data.rulemapping.length > 0 ? data.rulemapping : [
              [
                {
                  ruleId: 4,
                  clientType: 0,
                  value: '',
                  enableCommTarget: false,
                  commTarget: ''
                }
              ]
            ]
            this.ruleSeq = data.ruleSeq
            this.$parent.reqData = data.ruleSeq
            this.ibTemplate = data.ibTemplate
            this.salesTemplate = data.salesTemplate
            this.tempHistory = [{TEMPLATE_ID:this.temp_name,VERSION:0}].concat(data.history)
            this.currentVersion = null
            if(this.tempHistory && this.tempHistory.length>0) this.currentVersion = this.tempHistory[0].VERSION
            if(!this.salesTemplate || this.salesTemplate.length == 0) this.temp_name = ''
          }
        })
      },
      onTemplateChange(){
        this.pageInit()
        this.$parent.currentTemplate = this.temp_name
      },
      onVersionChange(version){
        if(version == 0){
          this.pageInit()
          return;
        }
        this.$http.get(api.getUrl20(this.curArea,URL_TEMPLATE_HISTORY)+'/'+this.temp_name+'/'+this.currentVersion).then((res) => {
          if (res.data.code === 200) {
              this.rule = res.data.data.rulemapping
          }
        })
      },
      createTemplate(){
        this.newTempName = ''
        this.newTempFlag = !this.newTempFlag
      },
      submit () { // 保存修改
        if(this.newTempFlag){
          let sameName = false
          this.ibTemplate.forEach(it=>{
              if(it.templateId==this.newTempName) sameName = true
          })
          this.salesTemplate.forEach(it=>{
            if(it.templateId==this.newTempName) sameName = true
          })
          if(sameName){
            alert(this.multiLanguage.alertMsg.templateExist)
            return
          }
        }
        function isTrueFn(element) { 
          return (element == true)
        }
        let arr = [this.$refs.ruleSetting.$validator.validateAll()]
        Promise.all(arr).then(result => {
          if (result.every(isTrueFn) && (this.enable ? this.checkRuleResultFn() : true)) {
            this.$http.post(api.getUrl20(this.curArea,URL_TEMPLATE_SAVE + '/1'),this.updateData).then(res => {
              if (res.data.code == 200 && res.data.msg == "OK") {
                this.showModal = true
                this.sucSave = true
                this.salesTemplate = res.data.data.salesTemplate
                this.temp_name = this.updateData.tmplateName
                this.tempHistory = res.data.data.history
                if(this.tempHistory && this.tempHistory.length>0) this.currentVersion = this.tempHistory[0].VERSION
              }
              else {
                this.showModal = true
                this.sucSave = false
              }
            })
          } else {
            this.showModal = true
            this.sucSave = false
          }
        })
      },
      checkIdFn (ruleItem) { // 检查id是否在关系图
        this.$http(api.getUrl20(this.curArea,URL_TOOLCHECKID),{params:{id: ruleItem.commTarget,type:'SL'}}).then(res => {
          let result = res.data.data.result
          if (!result) {
            alert(this.multiLanguage.alertMsg.noAccount)
            ruleItem.commTarget = ''
          }
        })
      },
      getLengthWithMatch(arr, callback) {
        let len = 0
        arr.forEach(a => {
          len += callback(a) ? 1 : 0
        })
        return len
      },
      hasSameItem(arr, names) {// 数组中的所有项的name属性的值是否都相同
        if (arr.length > 1) {
          let target = arr[0] // 参照物
          for (let i = 1; i < arr.length; i++) {
            if (this.isSameObject(target, arr[i], names)) return true
          }
        }
        return false
      },
      isSameObject(obj1, obj2, properties) {// 判断两个对象的所有properties是否都相同
        for (let p of properties) {
          if (obj1[p] !== obj2[p]) return false
        }
        return true
      },
      checkRuleSetting2(rules) { // 规则设定检查2
        let falseCommTargetLength = this.getLengthWithMatch(rules, r => !r.enableCommTarget)
        if (falseCommTargetLength === 0) return true //规则中没有为false的项
        if (falseCommTargetLength != rules.length) { // enableCommTarget存在不相同
          // alert('分配账号设定不同。')
          alert(this.multiLanguage.alertMsg.checkRuleFail1)
          return false
        } 

        if (this.getLengthWithMatch(rules, r => r.ruleId === 4) > 0) {
          if (this.getLengthWithMatch(rules, r => r.ruleId === 7 || r.ruleId === 8) > 0) {
            // alert('固定金额与固定金额(普通组别)、固定金额(VIP 组别)不能同时选择。')
            alert(this.multiLanguage.alertMsg.checkRuleFail2)
            return false
          }
        }

        let zeroClientTypeLength = this.getLengthWithMatch(rules, r => r.clientType === 0)
        if (zeroClientTypeLength > 0) { // ruleId 不能重复
          if (this.hasSameItem(rules, ['ruleId'])) alert(this.multiLanguage.alertMsg.checkRuleFail3) // alert('相同规则下，全部客户类型与其他客户类型冲突') 
          return !this.hasSameItem(rules, ['ruleId'])
        } else { // 项与项之间的ruleId和clientType不能相同
          if (this.hasSameItem(rules, ['ruleId', 'clientType'])) alert(this.multiLanguage.alertMsg.checkRuleFail4) //alert('存在重复的规则设定')
          return !this.hasSameItem(rules, ['ruleId', 'clientType'])
        }
        return true
      },
      checkRuleSetting1(rule) { // 规则设定检查1
        let checkRule = {}
        for (let val of rule) {
          for (let r of val) {
            if (r.ruleId == 5) {
              if (!checkRule[`${r.ruleId}-clientType`]) {
                checkRule[`${r.ruleId}-clientType`] = { count: 1, content: JSON.stringify({ clientType: r.clientType }) }
              } else {
                if (JSON.stringify({ clientType: r.clientType }) != checkRule[`${r.ruleId}-clientType`].content) {
                    return false
                } else {
                    checkRule[`${r.ruleId}-clientType`].count++
                }
              }
            }
          }
        }
        for (let key in checkRule) {
          if (checkRule[key].count != rule.length) { 
            //alert('存在“分层最高金额”这个规则时，每个级别都必须有一条“分层最高金额”，并保证“客户类型”一致')
            alert(this.multiLanguage.alertMsg.checkRuleFail5)
            return false
          }
        }
        return true
      },
      checkRuleResultFn() {
        let result = []
        for (let rule of this.updateData.rule) {
          result.push(this.checkRuleSetting2(rule))
        }
        if (result.every(r => r === true) && this.checkRuleSetting1(this.updateData.rule)) {
          // console.log('1_',result,this.checkRuleSetting1(this.updateData.rule))
          return true
        }
        else {
          // console.log('2_',result,this.checkRuleSetting1(this.updateData.rule))
          return false
        }
      },
      normSetFn (path) {// 拿到内设数据
        this.$http.get(api.getUrl20(this.curArea,URL_DEFAULT)+path).then((res) => {
          if (res.data.code === 200) {
              this.rule = res.data.data.rulemapping
          }
        })
      },
      dataFormat(date){
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
    },
    watch: {
      curArea () {
        this.$parent.currentTemplate = 'SALES_DEFAULT'
        this.temp_name = 'SALES_DEFAULT'
        this.pageInit()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .commissionDatum{
    input[type='checkbox']{
      vertical-align: middle;
      margin-top: 0;
    }
    .title{
      position: relative;
      border-bottom: 2px solid #3F51B5;
      input[type='checkbox']{
        width: 22px;
        height: 22px;
      }
      span{
        color: #3F51B5;
        font-weight: 550;
        font-size: 15px;
      }
      .template_name{
        width: 250px;
        height: 30px;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 3px;
      }
      .enable-btn{
        width: 15px;
        height: 15px;
      }
      .enable-text{
        font-size: 16px;
        font-weight: 700;
        color: #F08712;
      }
      .table-title{
        font-size: 20px;
        margin-left: 20px;
      }
      .btn-box{
        height: 50px;
        button{
          margin-left: 10px;
          background-color: #3f51b5;
          color:#fff;
        }
        span{
          color: #fff;
        }
      }
    }
    .last-update-box{
      margin-top: 20px;
      text-align: right;
      color: #3f51b5;
      font-weight: 550;
      font-size: 16px;
    }
    .cpa-switch-box{
      margin: 5px 0 10px;
      .cpa-switch{
        .internal{
          border-radius: 3px 0 0 3px;
        }
        .CPA{
          border-radius: 0;
          margin-left: -4px;
        }
        .internalAndCPA{
          border-radius: 0 3px 3px 0;
          margin-left: -5px
        }
        .active{
          background-color: #3F51B5!important;
          color: #fff!important;
        }
        .default-color{
          color: #333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// saleTemplateContent.vue?0ee66182